// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type AiChatSessionsQueryVariables = Types.Exact<{
  usage: Types.AiAssistantUsage;
}>;

export type AiChatSessionsQuery = { __typename?: 'Query' } & {
  aiChatSessions: Array<
    { __typename?: 'AIChatSessionSummary' } & Pick<
      Types.AiChatSessionSummary,
      'sessionId' | 'firstMessageAt' | 'lastMessageAt' | 'lastMessageFirstLine'
    >
  >;
};

export const AiChatSessionsDocument = /*#__PURE__*/ gql`
    query AiChatSessions($usage: AIAssistantUsage!) {
  aiChatSessions(usage: $usage) {
    sessionId
    firstMessageAt
    lastMessageAt
    lastMessageFirstLine
  }
}
    `;

/**
 * __useAiChatSessionsQuery__
 *
 * To run a query within a React component, call `useAiChatSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiChatSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiChatSessionsQuery({
 *   variables: {
 *      usage: // value for 'usage'
 *   },
 * });
 */
export function useAiChatSessionsQuery(
  baseOptions: Apollo.QueryHookOptions<AiChatSessionsQuery, AiChatSessionsQueryVariables> &
    ({ variables: AiChatSessionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiChatSessionsQuery, AiChatSessionsQueryVariables>(AiChatSessionsDocument, options);
}
export function useAiChatSessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AiChatSessionsQuery, AiChatSessionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiChatSessionsQuery, AiChatSessionsQueryVariables>(AiChatSessionsDocument, options);
}
// @ts-expect-error
export function useAiChatSessionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AiChatSessionsQuery, AiChatSessionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<AiChatSessionsQuery, AiChatSessionsQueryVariables>;
export function useAiChatSessionsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiChatSessionsQuery, AiChatSessionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<AiChatSessionsQuery | undefined, AiChatSessionsQueryVariables>;
export function useAiChatSessionsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiChatSessionsQuery, AiChatSessionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiChatSessionsQuery, AiChatSessionsQueryVariables>(AiChatSessionsDocument, options);
}
export type AiChatSessionsQueryHookResult = ReturnType<typeof useAiChatSessionsQuery>;
export type AiChatSessionsLazyQueryHookResult = ReturnType<typeof useAiChatSessionsLazyQuery>;
export type AiChatSessionsSuspenseQueryHookResult = ReturnType<typeof useAiChatSessionsSuspenseQuery>;
